
import { useContext } from "@wordpress/element";
import placeholderImageUrl from '../../../../includes/assets/img/profile-image.png';
import BlockContext from '../context/blockContext';

function ProfileImage() {
    const { attributes } = useContext(BlockContext);
    const { profileImage } = attributes;
  return (
   <div className="profile-img">
        <img
            src={profileImage?.url || placeholderImageUrl}
            alt={profileImage?.alt || "Profile Image"}
        />
    </div>
  )
}

export default ProfileImage
